
import { call, takeEvery, put } from 'redux-saga/effects';
import { message } from 'antd';
import login from '../Actions/login';
import auth from '../auth';
import { loginUserRequest } from '../Api/Authenticate';
import { setSessionData } from '../Helpers/loginHelper';
import license from '../Actions/license';
import user from '../Actions/user';
import { startLoading, stopLoading } from '../LoadingHelper';
import { persistor } from '../Reducers';
import { CATEGORY_GA, eventGA } from  '../Helpers/GoogleAnalytics';
const { types } = login;
const { updateLoginStatus } = login.actions;
const { getLicenseData, getLicensesHistorical, getBalanceData } = license.actions;
const { getUserInfo } = user.actions;

export function* authenticate({ data }) {
    const loadingId = yield call(startLoading, 'authenticateLoading');
    try {
        let { values, history } = data;
        const response = yield call(loginUserRequest, values);
        if(response.status === '409') {//ya existe en timbrado, se le creó el preuser automaticamente y se le redirije a la pantalla de compra
            message.info(response.message, 5);
            history.push(`/buy-license/preUser/${values.username}`);            
            eventGA(CATEGORY_GA.session.startSessionWithoutLicense);
            return;
        }
        if (response.status === 'success') {            
            yield put(updateLoginStatus({isLogged: true}));
            setSessionData({response, message, auth, history });
            yield put(getLicenseData());
            yield put(getLicensesHistorical());
            yield put(getBalanceData());
            yield put(getUserInfo(values.username));
            eventGA(CATEGORY_GA.session.startSession);
        } else {
            message.error(response.message, 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

export function* logout() {
    const loadingId = yield call(startLoading);
    try {
        persistor.purge();
        auth.logOut();
        eventGA(CATEGORY_GA.session.endSession);
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

export function* removeSessionData() {
    const loadingId = yield call(startLoading);
    try {
        persistor.purge();
        auth.removeToken();
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}


export function* loginSaga() {
    yield takeEvery(types.AUTHENTICATE, authenticate);
    yield takeEvery(types.LOGOUT, logout);    
}
